import { render, staticRenderFns } from "./ManageProject.vue?vue&type=template&id=12e14956&"
import script from "./ManageProject.vue?vue&type=script&lang=js&"
export * from "./ManageProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports